module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/system/waybill/specific-waybill-modal/specific-waybill-modal.component.css
// module id = ./src/app/system/waybill/specific-waybill-modal/specific-waybill-modal.component.css
// module chunks = main